import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme, { colors: any }>((theme) => ({
  // Alert box
  alertBoxDateTimeSchedule: {
    borderRadius: 4,
    padding: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#E6F0F8',
    color: '#1F78C0',
  },
  // Buttons
  evaluateButton: {
    backgroundColor: (props) => props.colors.accentColorBackground,
    color: (props) => props.colors.textAccentColor,
    width: 110,
    height: 36,
    '&:hover': {
      backgroundColor: (props) => props.colors.accentColorBackground,
    },
  },
  evaluateButtonContainer: {
    marginTop: 32,
    display: 'flex',
    width: '100%',
    alignSelf: 'flex-end',
    justifyContent: 'flex-end',
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {
      marginTop: 12,
      marginBottom: 8,
    },
  },
  evaluateButtonText: {
    fontFamily: 'Roboto',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  // Close button
  closeButton: {
    color: '#6B7280',
    alignSelf: 'flex-end',
    marginBottom: 16,
    padding: 8,
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
      marginTop: 0,
      padding: 4,
    },
  },
  // Completed evaluation screen
  completedEvaluationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
  },
  completedScheduleSubtitle: {
    textAlign: 'center',
    color: (props) => props.colors.textBody,
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  completedScheduleTitle: {
    color: (props) => props.colors.textBody,
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(20),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  completedTitleGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginBottom: 24,
    width: '100%',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      gap: 8,
      marginBottom: 12,
    },
  },
  completedInfoGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginBottom: 32,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      gap: 8,
      marginBottom: 12,
    },
  },
  completedThankYouGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginBottom: 16,
    width: '100%',
  },
  concludeButton: {
    marginBottom: 15,
    backgroundColor: (props) => props.colors.accentColorBackground,
    color: (props) => props.colors.textAccentColor,
    width: 97,
    height: 36,
    '&:hover': {
      backgroundColor: (props) => props.colors.accentColorBackground,
    },
  },
  // Containers
  evaluationAreaContainer: {
    width: '100%',
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 8,
    },
  },
  evaluationFormContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '16px 32px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 12px 12px 12px',
      maxHeight: 'calc(100vh - 64px)',
      overflowY: 'auto',
      justifyContent: 'flex-start',
    },
  },
  // Info text (unused)
  infoStepText: {
    fontSize: theme.typography.pxToRem(12),
    color: 'rgba(102, 112, 133, 1)',
    fontWeight: 400,
    fontFamily: 'Roboto',
    marginBottom: 4,
    marginTop: 8,
  },
  // Main title
  mainEvaluationTitle: {
    textAlign: 'center',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
  },
  // Rating
  ratingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  ratingStarIcon: {
    width: 36,
    height: 32,
    color: 'rgba(250, 176, 5, 1)',
    [theme.breakpoints.down('sm')]: {
      width: 28,
      height: 24,
    },
  },
  ratingTitle: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  // Text fields
  textFieldCommentContainer: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: '#F9FAFB',
      '& fieldset': {
        borderColor: '#E5E7EB',
      },
      '&:hover fieldset': {
        borderColor: '#D1D5DB',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#D1D5DB',
      },
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 12,
    },
  },
  textFieldCommentInput: {
    color: '#6B7280',
    minWidth: '100%',
    width: '100%',
    height: 56,
    overflow: 'auto',
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      height: 48,
    },
  },
  // Thank you box
  thankYouImageBox: {
    borderRadius: 8,
    border: '1px solid #E5E7EB',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    width: '100%',
    marginTop: 16,
    paddingTop: 16,
    paddingBottom: 16,
    [theme.breakpoints.down('sm')]: {
      marginTop: 6,
      paddingTop: 8,
      paddingBottom: 8,
      gap: 6,
    },
  },
  // Action buttons
  actionButtonsContainer: {
    display: 'flex',
    width: '100%',
    gap: 16,
    marginTop: 24,
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginTop: 12,
      gap: 8,
    },
  },
  outlinedButton: {
    borderRadius: 4,
    border: (props) => `1px solid ${props.colors.accentColorBackground}`,
    color: (props) => props.colors.accentColorBackground,
    padding: '10px 24px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  outlinedButtonText: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
  },
  primaryButton: {
    borderRadius: 4,
    backgroundColor: (props) => props.colors.accentColorBackground,
    color: (props) => props.colors.textAccentColor,
    padding: '10px 24px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: (props) => props.colors.accentColorBackground,
    },
  },
  primaryButtonText: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
  },
  // Unused
  concludedContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  descriptionRatingText: {
    fontSize: theme.typography.pxToRem(14),
    color: '#6B7280',
    margin: 0,
  },
}))
